import qs from 'qs';
import client from '@/api/base';

export default {
  async scheduleChemMeeting(coachId, data) {
    const response = await client.post(`events/schedule/book/chem/${coachId}/`, data);
    return response;
  },

  async cancelCoachMeeting(meetingId, data) {
    const response = await client.patch(`events/schedule/${meetingId}/cancel/`, data);
    return response;
  },

  async getCoachAvailableTime(uuid, params) {
    const response = await client.get(`coaching/schedule/coach/${uuid}/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },
};
